import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const InspectByExpert = () => (
  <Stack
    sx={{
      aspectRatio: '799 / 506',
      backgroundImage: "url('assets/images/Inspection/Expert.webp')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      pt: '100px',
      pl: '110px !important',
      pb: '40px',
      justifyContent: 'space-between',
    }}
  >
    <Typography fontSize="46px" fontWeight={700} color="#FFFFFF">
      Inspected by Experts. Backed by Warranty!{' '}
    </Typography>
    <Stack
      width="fit-content"
      gap={4}
      sx={{
        borderRadius: '210px',
        p: 5,
        backgroundImage: 'radial-gradient(229.23% 229.23% at 45.67% 100%, rgba(18, 18, 18, 0) 0%, #121212 100%)',
      }}
    >
      <Box>
        <Typography fontSize="20px" mt={2} color="#FFFFFF" fontWeight={600} maxWidth="410px">
          The FOCUS Inspection Warranty covers unexpected engine or major component
        </Typography>
        <Typography fontSize="20px" color="#FFFFFF" fontWeight={400} maxWidth="410px">
          issues if they arise after our certified inspection clears them.ted and unsure.
        </Typography>
      </Box>
      <FocusInspectionButtonWeb title="Get Warranty Assured Inspection" onClick={() => console.log('Button clicked')} />
    </Stack>
  </Stack>
);

export default InspectByExpert;
